import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["children", "className", "components", "componentsProps", "isLeftDisabled", "isLeftHidden", "isRightDisabled", "isRightHidden", "leftArrowButtonText", "onLeftClick", "onRightClick", "rightArrowButtonText", "onFocusedDayChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import Typography from '@mui/material/Typography';
import { useTheme, styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import ArrowLeftIcon from '../svg-icons/ArrowLeft';
import ArrowRightIcon from '../svg-icons/ArrowRight';
var PickersArrowSwitcherRoot = styled('div')({
  display: 'flex'
});
var PickersArrowSwitcherSpacer = styled('div')(function (_ref) {
  var theme = _ref.theme;
  return {
    width: theme.spacing(3)
  };
});
var PickersArrowSwitcherButton = styled(IconButton)(function (_ref2) {
  var ownerState = _ref2.ownerState;
  return _objectSpread({}, ownerState.hidden && {
    visibility: 'hidden'
  });
});
var PickersArrowSwitcher = /*#__PURE__*/React.forwardRef(function PickersArrowSwitcher(props, ref) {
  var children = props.children,
    className = props.className,
    _props$components = props.components,
    components = _props$components === void 0 ? {} : _props$components,
    _props$componentsProp = props.componentsProps,
    componentsProps = _props$componentsProp === void 0 ? {} : _props$componentsProp,
    isLeftDisabled = props.isLeftDisabled,
    isLeftHidden = props.isLeftHidden,
    isRightDisabled = props.isRightDisabled,
    isRightHidden = props.isRightHidden,
    leftArrowButtonText = props.leftArrowButtonText,
    onLeftClick = props.onLeftClick,
    onRightClick = props.onRightClick,
    rightArrowButtonText = props.rightArrowButtonText,
    onFocusedDayChange = props.onFocusedDayChange,
    other = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var isRtl = theme.direction === 'rtl';
  var leftArrowButtonProps = componentsProps.leftArrowButton || {};
  var LeftArrowIcon = components.LeftArrowIcon || ArrowLeftIcon;
  var rightArrowButtonProps = componentsProps.rightArrowButton || {};
  var RightArrowIcon = components.RightArrowIcon || ArrowRightIcon;
  var ownerState = props;
  return /*#__PURE__*/React.createElement(PickersArrowSwitcherRoot, _extends({
    ref: ref,
    className: className,
    ownerState: ownerState
  }, other), /*#__PURE__*/React.createElement(PickersArrowSwitcherButton, _extends({
    as: components.LeftArrowButton,
    size: "small",
    "aria-label": leftArrowButtonText,
    title: leftArrowButtonText,
    disabled: isLeftDisabled,
    edge: "end",
    onClick: onLeftClick
  }, leftArrowButtonProps, {
    className: leftArrowButtonProps.className,
    ownerState: _objectSpread(_objectSpread(_objectSpread({}, ownerState), leftArrowButtonProps), {}, {
      hidden: isLeftHidden
    }),
    tabIndex: isLeftHidden || isLeftDisabled ? -1 : 0,
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Tab') {
        onFocusedDayChange === null || onFocusedDayChange === void 0 || onFocusedDayChange(null);
      }
    }
  }), isRtl ? /*#__PURE__*/React.createElement(RightArrowIcon, null) : /*#__PURE__*/React.createElement(LeftArrowIcon, null)), children ? /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    component: "span"
  }, children) : /*#__PURE__*/React.createElement(PickersArrowSwitcherSpacer, {
    ownerState: ownerState
  }), /*#__PURE__*/React.createElement(PickersArrowSwitcherButton, _extends({
    as: components.RightArrowButton,
    size: "small",
    "aria-label": rightArrowButtonText,
    title: rightArrowButtonText,
    edge: "start",
    disabled: isRightDisabled,
    onClick: onRightClick
  }, rightArrowButtonProps, {
    className: rightArrowButtonProps.className,
    ownerState: _objectSpread(_objectSpread(_objectSpread({}, ownerState), rightArrowButtonProps), {}, {
      hidden: isRightHidden
    }),
    tabIndex: isRightHidden || isRightDisabled ? -1 : 0,
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Tab') {
        onFocusedDayChange === null || onFocusedDayChange === void 0 || onFocusedDayChange(null);
      }
    }
  }), isRtl ? /*#__PURE__*/React.createElement(LeftArrowIcon, null) : /*#__PURE__*/React.createElement(RightArrowIcon, null)));
});
export default PickersArrowSwitcher;